import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';
import { RoutePlanPage } from './route-plan/route-plan.page';
import { FlightPlanRoutingModule } from './flight-plan.routing.module';
import { IonBottomDrawerModule } from '@app/shared/compat/ion-bottom-drawer';
import { RoutePlanEditComponent } from './route-plan/route-plan-edit/route-plan-edit.component';
import { RoutePlanViewComponent } from './route-plan/route-plan-view/route-plan-view.component';
import { RouteMapComponent } from './route-plan/route-map/route-map.component';
import { PayloadComponent } from './route-plan/payload/payload.component';
import { AtcDataComponent } from './route-plan/atc-data/atc-data.component';
import { DestRouteComponent } from './route-plan/dest-route/dest-route.component';
import { AlternateComponent } from './route-plan/alternate/alternate.component';
import { FuelComponent } from './route-plan/fuel/fuel.component';
import { AvoidCountryComponent } from './route-plan/avoid-country/avoid-country.component';
import { EdtoComponent } from './route-plan/edto/edto.component';
import { WeatherComponent } from './route-plan/weather/weather.component';
import { AirportsComponent } from './route-plan/airports/airports.component';
import { NotamsComponent } from './route-plan/notams/notams.component';
import { CorePipeModule } from '@app/core/pipes/core-pipe.module';
import { AirportdetailscardComponent } from './route-plan/airportdetailscard/airportdetailscard.component';
import { CoreComponentModule } from '@app/core/components/core-component.module';
import { SharedDirectiveModule } from '@app/shared/directives/shared-directive.module';
import { FlightPlanWarningsComponent } from '@app/flightplans/flight-plan-ui/flight-plan-warnings/flight-plan-warnings.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FlightPlanRoutingModule,
    IonBottomDrawerModule,
    CorePipeModule,
    CoreComponentModule,
    SharedDirectiveModule
  ],
  declarations: [
    RoutePlanPage,
    RoutePlanEditComponent,
    RoutePlanViewComponent,
    RouteMapComponent,
    PayloadComponent,
    AtcDataComponent,
    DestRouteComponent,
    AlternateComponent,
    FuelComponent,
    AvoidCountryComponent,
    EdtoComponent,
    WeatherComponent,
    NotamsComponent,
    AirportsComponent,
    AirportdetailscardComponent,
    FlightPlanWarningsComponent
  ],
  exports: [
    RoutePlanEditComponent,
    RoutePlanViewComponent,
    RouteMapComponent,
    PayloadComponent,
    AtcDataComponent,
    DestRouteComponent,
    AlternateComponent,
    FuelComponent,
    AvoidCountryComponent,
    EdtoComponent,
    WeatherComponent,
    NotamsComponent,
    AirportsComponent,
    AirportdetailscardComponent,
    FlightPlanWarningsComponent
  ],
})
export class FlightPlanModule {}
